import React from 'react';
import '../styles/ShimmerLoader.css';

interface ShimmerLoaderProps {
  type?: 'details' | 'list' | 'card';
}

const ShimmerLoader: React.FC<ShimmerLoaderProps> = ({ type = 'details' }) => {
  if (type === 'details') {
    return (
      <div className="shimmer-details-container">
        {/* Header Section */}
        <div className="shimmer-header">
          <div className="shimmer-image shimmer-hero-image"></div>
          <div className="shimmer-header-content">
            <div className="shimmer-line shimmer-title"></div>
            <div className="shimmer-line shimmer-subtitle"></div>
          </div>
        </div>

        {/* Tabs */}
        <div className="shimmer-tabs">
          <div className="shimmer-tab"></div>
          <div className="shimmer-tab"></div>
          <div className="shimmer-tab"></div>
          <div className="shimmer-tab"></div>
        </div>

        {/* Content Sections */}
        <div className="shimmer-content">
          {/* Section 1 */}
          <div className="shimmer-section">
            <div className="shimmer-line shimmer-section-title"></div>
            <div className="shimmer-card">
              <div className="shimmer-line shimmer-text-line"></div>
              <div className="shimmer-line shimmer-text-line"></div>
              <div className="shimmer-line shimmer-text-line shimmer-short"></div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="shimmer-section">
            <div className="shimmer-line shimmer-section-title"></div>
            <div className="shimmer-card">
              <div className="shimmer-line shimmer-text-line"></div>
              <div className="shimmer-line shimmer-text-line"></div>
              <div className="shimmer-line shimmer-text-line shimmer-short"></div>
            </div>
          </div>

          {/* Gallery Grid */}
          <div className="shimmer-section">
            <div className="shimmer-line shimmer-section-title"></div>
            <div className="shimmer-grid">
              <div className="shimmer-image shimmer-grid-item"></div>
              <div className="shimmer-image shimmer-grid-item"></div>
              <div className="shimmer-image shimmer-grid-item"></div>
              <div className="shimmer-image shimmer-grid-item"></div>
            </div>
          </div>

          {/* Table Section */}
          <div className="shimmer-section">
            <div className="shimmer-line shimmer-section-title"></div>
            <div className="shimmer-table">
              <div className="shimmer-table-row">
                <div className="shimmer-line shimmer-table-cell"></div>
                <div className="shimmer-line shimmer-table-cell"></div>
                <div className="shimmer-line shimmer-table-cell"></div>
              </div>
              <div className="shimmer-table-row">
                <div className="shimmer-line shimmer-table-cell"></div>
                <div className="shimmer-line shimmer-table-cell"></div>
                <div className="shimmer-line shimmer-table-cell"></div>
              </div>
              <div className="shimmer-table-row">
                <div className="shimmer-line shimmer-table-cell"></div>
                <div className="shimmer-line shimmer-table-cell"></div>
                <div className="shimmer-line shimmer-table-cell"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ShimmerLoader;
